// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/feed.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Member } from "./common_pb.ts";
import { EmailMessage, PhoneCall, TextMessage } from "./conversation_pb.ts";
import { Task, TaskBlock, TaskChangeEvent } from "./tasks_pb.ts";
import { VideoRoom } from "./video_pb.ts";
import { Document } from "./documents_pb.ts";
import { DelegationTask, DelegationTaskComment } from "./delegations_pb.ts";

/**
 * @generated from enum protogen.Medium
 */
export enum Medium {
  /**
   * @generated from enum value: MEDIUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIUM_SMS = 1;
   */
  SMS = 1,

  /**
   * @generated from enum value: MEDIUM_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: MEDIUM_PHONE = 3;
   */
  PHONE = 3,

  /**
   * @generated from enum value: MEDIUM_TASK_COMMENT = 4;
   */
  TASK_COMMENT = 4,

  /**
   * @generated from enum value: MEDIUM_TASK_CHANGE_EVENT = 5;
   */
  TASK_CHANGE_EVENT = 5,

  /**
   * @generated from enum value: MEDIUM_VIDEO = 6;
   */
  VIDEO = 6,

  /**
   * @generated from enum value: MEDIUM_DOCUMENT = 7;
   */
  DOCUMENT = 7,

  /**
   * @generated from enum value: MEDIUM_SECRET = 8;
   */
  SECRET = 8,

  /**
   * @generated from enum value: MEDIUM_FORUM_POST = 9;
   */
  FORUM_POST = 9,

  /**
   * @generated from enum value: MEDIUM_FORUM_COMMENT = 10;
   */
  FORUM_COMMENT = 10,

  /**
   * @generated from enum value: MEDIUM_BADGE = 11;
   */
  BADGE = 11,

  /**
   * @generated from enum value: MEDIUM_PLAYBOOK = 12;
   */
  PLAYBOOK = 12,

  /**
   * @generated from enum value: MEDIUM_DELEGATION_TASK_COMMENT = 13;
   */
  DELEGATION_TASK_COMMENT = 13,

  /**
   * @generated from enum value: MEDIUM_DELEGATION_TASK_CREATED = 14;
   */
  DELEGATION_TASK_CREATED = 14,

  /**
   * @generated from enum value: MEDIUM_SMS_BOT = 15;
   */
  SMS_BOT = 15,

  /**
   * @generated from enum value: MEDIUM_LINQ_IMESSAGE = 16;
   */
  LINQ_IMESSAGE = 16,

  /**
   * @generated from enum value: MEDIUM_APP_AGENT = 17;
   */
  APP_AGENT = 17,
}
// Retrieve enum metadata with: proto3.getEnumType(Medium)
proto3.util.setEnumType(Medium, "protogen.Medium", [
  { no: 0, name: "MEDIUM_UNSPECIFIED" },
  { no: 1, name: "MEDIUM_SMS" },
  { no: 2, name: "MEDIUM_EMAIL" },
  { no: 3, name: "MEDIUM_PHONE" },
  { no: 4, name: "MEDIUM_TASK_COMMENT" },
  { no: 5, name: "MEDIUM_TASK_CHANGE_EVENT" },
  { no: 6, name: "MEDIUM_VIDEO" },
  { no: 7, name: "MEDIUM_DOCUMENT" },
  { no: 8, name: "MEDIUM_SECRET" },
  { no: 9, name: "MEDIUM_FORUM_POST" },
  { no: 10, name: "MEDIUM_FORUM_COMMENT" },
  { no: 11, name: "MEDIUM_BADGE" },
  { no: 12, name: "MEDIUM_PLAYBOOK" },
  { no: 13, name: "MEDIUM_DELEGATION_TASK_COMMENT" },
  { no: 14, name: "MEDIUM_DELEGATION_TASK_CREATED" },
  { no: 15, name: "MEDIUM_SMS_BOT" },
  { no: 16, name: "MEDIUM_LINQ_IMESSAGE" },
  { no: 17, name: "MEDIUM_APP_AGENT" },
]);

/**
 * @generated from enum protogen.FeedEntryType
 */
export enum FeedEntryType {
  /**
   * @generated from enum value: FEED_ENTRY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_MESSAGE = 1;
   */
  MESSAGE = 1,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_PHONE_CALL = 3;
   */
  PHONE_CALL = 3,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_TASK_ACTIVITY = 4;
   */
  TASK_ACTIVITY = 4,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_ADMIN_ALL = 5;
   */
  ADMIN_ALL = 5,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_VIDEO_CALL = 6;
   */
  VIDEO_CALL = 6,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_DOCUMENT_ACTIVITY = 7;
   */
  DOCUMENT_ACTIVITY = 7,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_SECRET_ACTIVITY = 8;
   */
  SECRET_ACTIVITY = 8,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_EMAIL_ACTION_ALIAS = 9;
   */
  EMAIL_ACTION_ALIAS = 9,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_FORUM_POST = 10;
   */
  FORUM_POST = 10,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_FORUM_COMMENT = 11;
   */
  FORUM_COMMENT = 11,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_BADGE = 12;
   */
  BADGE = 12,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_PLAYBOOK = 13;
   */
  PLAYBOOK = 13,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_DELEGATION_TASK_ACTIVITY = 14;
   */
  DELEGATION_TASK_ACTIVITY = 14,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_PHOTOS = 15;
   */
  PHOTOS = 15,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_LINKS = 16;
   */
  LINKS = 16,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_MESSAGE_SCHEDULED = 17;
   */
  MESSAGE_SCHEDULED = 17,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_AGENT_CONVERSATION = 18;
   */
  AGENT_CONVERSATION = 18,

  /**
   * @generated from enum value: FEED_ENTRY_TYPE_AGENT_CRON = 19;
   */
  AGENT_CRON = 19,
}
// Retrieve enum metadata with: proto3.getEnumType(FeedEntryType)
proto3.util.setEnumType(FeedEntryType, "protogen.FeedEntryType", [
  { no: 0, name: "FEED_ENTRY_TYPE_UNSPECIFIED" },
  { no: 1, name: "FEED_ENTRY_TYPE_MESSAGE" },
  { no: 2, name: "FEED_ENTRY_TYPE_EMAIL" },
  { no: 3, name: "FEED_ENTRY_TYPE_PHONE_CALL" },
  { no: 4, name: "FEED_ENTRY_TYPE_TASK_ACTIVITY" },
  { no: 5, name: "FEED_ENTRY_TYPE_ADMIN_ALL" },
  { no: 6, name: "FEED_ENTRY_TYPE_VIDEO_CALL" },
  { no: 7, name: "FEED_ENTRY_TYPE_DOCUMENT_ACTIVITY" },
  { no: 8, name: "FEED_ENTRY_TYPE_SECRET_ACTIVITY" },
  { no: 9, name: "FEED_ENTRY_TYPE_EMAIL_ACTION_ALIAS" },
  { no: 10, name: "FEED_ENTRY_TYPE_FORUM_POST" },
  { no: 11, name: "FEED_ENTRY_TYPE_FORUM_COMMENT" },
  { no: 12, name: "FEED_ENTRY_TYPE_BADGE" },
  { no: 13, name: "FEED_ENTRY_TYPE_PLAYBOOK" },
  { no: 14, name: "FEED_ENTRY_TYPE_DELEGATION_TASK_ACTIVITY" },
  { no: 15, name: "FEED_ENTRY_TYPE_PHOTOS" },
  { no: 16, name: "FEED_ENTRY_TYPE_LINKS" },
  { no: 17, name: "FEED_ENTRY_TYPE_MESSAGE_SCHEDULED" },
  { no: 18, name: "FEED_ENTRY_TYPE_AGENT_CONVERSATION" },
  { no: 19, name: "FEED_ENTRY_TYPE_AGENT_CRON" },
]);

/**
 * @generated from message protogen.Conversation
 */
export class Conversation extends Message<Conversation> {
  /**
   * Lets use this instead of "ID"
   *
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string familyRef = 2;
   */
  familyRef = "";

  /**
   * enum???
   *
   * @generated from field: protogen.Medium medium = 3;
   */
  medium = Medium.UNSPECIFIED;

  /**
   * @generated from field: int64 lastUpdateSec = 4;
   */
  lastUpdateSec = protoInt64.zero;

  /**
   * @generated from field: repeated protogen.Member members = 5;
   */
  members: Member[] = [];

  constructor(data?: PartialMessage<Conversation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.Conversation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "medium", kind: "enum", T: proto3.getEnumType(Medium) },
    { no: 4, name: "lastUpdateSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "members", kind: "message", T: Member, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Conversation {
    return new Conversation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Conversation {
    return new Conversation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Conversation {
    return new Conversation().fromJsonString(jsonString, options);
  }

  static equals(a: Conversation | PlainMessage<Conversation> | undefined, b: Conversation | PlainMessage<Conversation> | undefined): boolean {
    return proto3.util.equals(Conversation, a, b);
  }
}

/**
 * @generated from message protogen.ForumPostEntry
 */
export class ForumPostEntry extends Message<ForumPostEntry> {
  /**
   * @generated from field: string postRef = 1;
   */
  postRef = "";

  /**
   * @generated from field: string postTitle = 2;
   */
  postTitle = "";

  constructor(data?: PartialMessage<ForumPostEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ForumPostEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "postRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ForumPostEntry {
    return new ForumPostEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ForumPostEntry {
    return new ForumPostEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ForumPostEntry {
    return new ForumPostEntry().fromJsonString(jsonString, options);
  }

  static equals(a: ForumPostEntry | PlainMessage<ForumPostEntry> | undefined, b: ForumPostEntry | PlainMessage<ForumPostEntry> | undefined): boolean {
    return proto3.util.equals(ForumPostEntry, a, b);
  }
}

/**
 * @generated from message protogen.ForumCommentEntry
 */
export class ForumCommentEntry extends Message<ForumCommentEntry> {
  /**
   * @generated from field: string commentRef = 1;
   */
  commentRef = "";

  /**
   * @generated from field: string postRef = 2;
   */
  postRef = "";

  /**
   * @generated from field: string postTitle = 3;
   */
  postTitle = "";

  /**
   * @generated from field: string commentPreview = 4;
   */
  commentPreview = "";

  constructor(data?: PartialMessage<ForumCommentEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ForumCommentEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "commentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "postTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "commentPreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ForumCommentEntry {
    return new ForumCommentEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ForumCommentEntry {
    return new ForumCommentEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ForumCommentEntry {
    return new ForumCommentEntry().fromJsonString(jsonString, options);
  }

  static equals(a: ForumCommentEntry | PlainMessage<ForumCommentEntry> | undefined, b: ForumCommentEntry | PlainMessage<ForumCommentEntry> | undefined): boolean {
    return proto3.util.equals(ForumCommentEntry, a, b);
  }
}

/**
 * @generated from message protogen.BadgeEntry
 */
export class BadgeEntry extends Message<BadgeEntry> {
  /**
   * @generated from field: string badgeName = 1;
   */
  badgeName = "";

  constructor(data?: PartialMessage<BadgeEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.BadgeEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badgeName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BadgeEntry {
    return new BadgeEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BadgeEntry {
    return new BadgeEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BadgeEntry {
    return new BadgeEntry().fromJsonString(jsonString, options);
  }

  static equals(a: BadgeEntry | PlainMessage<BadgeEntry> | undefined, b: BadgeEntry | PlainMessage<BadgeEntry> | undefined): boolean {
    return proto3.util.equals(BadgeEntry, a, b);
  }
}

/**
 * @generated from message protogen.PlaybookEntry
 */
export class PlaybookEntry extends Message<PlaybookEntry> {
  /**
   * @generated from field: string playbookRef = 1;
   */
  playbookRef = "";

  /**
   * @generated from field: string playbookName = 2;
   */
  playbookName = "";

  constructor(data?: PartialMessage<PlaybookEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.PlaybookEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "playbookRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "playbookName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlaybookEntry {
    return new PlaybookEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlaybookEntry {
    return new PlaybookEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlaybookEntry {
    return new PlaybookEntry().fromJsonString(jsonString, options);
  }

  static equals(a: PlaybookEntry | PlainMessage<PlaybookEntry> | undefined, b: PlaybookEntry | PlainMessage<PlaybookEntry> | undefined): boolean {
    return proto3.util.equals(PlaybookEntry, a, b);
  }
}

/**
 * @generated from message protogen.AgentConversationEntry
 */
export class AgentConversationEntry extends Message<AgentConversationEntry> {
  /**
   * @generated from field: string conversationRef = 1;
   */
  conversationRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  constructor(data?: PartialMessage<AgentConversationEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentConversationEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentConversationEntry {
    return new AgentConversationEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentConversationEntry {
    return new AgentConversationEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentConversationEntry {
    return new AgentConversationEntry().fromJsonString(jsonString, options);
  }

  static equals(a: AgentConversationEntry | PlainMessage<AgentConversationEntry> | undefined, b: AgentConversationEntry | PlainMessage<AgentConversationEntry> | undefined): boolean {
    return proto3.util.equals(AgentConversationEntry, a, b);
  }
}

/**
 * @generated from message protogen.AgentCronEntry
 */
export class AgentCronEntry extends Message<AgentCronEntry> {
  /**
   * @generated from field: string agentCronRef = 1;
   */
  agentCronRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string scheduleSummary = 3;
   */
  scheduleSummary = "";

  constructor(data?: PartialMessage<AgentCronEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentCronEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCronRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scheduleSummary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentCronEntry {
    return new AgentCronEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentCronEntry {
    return new AgentCronEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentCronEntry {
    return new AgentCronEntry().fromJsonString(jsonString, options);
  }

  static equals(a: AgentCronEntry | PlainMessage<AgentCronEntry> | undefined, b: AgentCronEntry | PlainMessage<AgentCronEntry> | undefined): boolean {
    return proto3.util.equals(AgentCronEntry, a, b);
  }
}

/**
 * @generated from message protogen.FeedEntry
 */
export class FeedEntry extends Message<FeedEntry> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string senderRef = 2;
   */
  senderRef = "";

  /**
   * @generated from field: int64 timestampSec = 3;
   */
  timestampSec = protoInt64.zero;

  /**
   * @generated from field: protogen.Medium medium = 4;
   */
  medium = Medium.UNSPECIFIED;

  /**
   * oneof content ???
   *
   * @generated from field: protogen.TextMessage textMessage = 5;
   */
  textMessage?: TextMessage;

  /**
   * @generated from field: protogen.EmailMessage emailMessage = 6;
   */
  emailMessage?: EmailMessage;

  /**
   * @generated from field: protogen.PhoneCall phoneCall = 7;
   */
  phoneCall?: PhoneCall;

  /**
   * Used to differentiate which user a message was sent to.
   *
   * @generated from field: repeated string recipientRefs = 8;
   */
  recipientRefs: string[] = [];

  /**
   * @generated from field: int64 session = 9;
   */
  session = protoInt64.zero;

  /**
   * @generated from field: protogen.TaskBlock taskBlock = 10;
   */
  taskBlock?: TaskBlock;

  /**
   * @generated from field: protogen.Task task = 11;
   */
  task?: Task;

  /**
   * @generated from field: protogen.TaskChangeEvent taskChangeEvent = 12;
   */
  taskChangeEvent?: TaskChangeEvent;

  /**
   * @generated from field: protogen.VideoRoom videoRoom = 13;
   */
  videoRoom?: VideoRoom;

  /**
   * @generated from field: protogen.Document document = 14;
   */
  document?: Document;

  /**
   * Let's limit the information we share here.
   *
   * @generated from field: string secretName = 15;
   */
  secretName = "";

  /**
   * @generated from field: bool unread = 16;
   */
  unread = false;

  /**
   * @generated from field: protogen.ForumPostEntry forumPost = 17;
   */
  forumPost?: ForumPostEntry;

  /**
   * @generated from field: protogen.ForumCommentEntry forumComment = 18;
   */
  forumComment?: ForumCommentEntry;

  /**
   * @generated from field: protogen.BadgeEntry badge = 19;
   */
  badge?: BadgeEntry;

  /**
   * @generated from field: protogen.PlaybookEntry playbook = 20;
   */
  playbook?: PlaybookEntry;

  /**
   * @generated from field: protogen.DelegationTask delegationTask = 21;
   */
  delegationTask?: DelegationTask;

  /**
   * @generated from field: protogen.DelegationTaskComment delegationTaskComment = 22;
   */
  delegationTaskComment?: DelegationTaskComment;

  /**
   * @generated from field: protogen.AgentConversationEntry agentConversation = 23;
   */
  agentConversation?: AgentConversationEntry;

  /**
   * @generated from field: protogen.AgentCronEntry agentCron = 24;
   */
  agentCron?: AgentCronEntry;

  constructor(data?: PartialMessage<FeedEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FeedEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "senderRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestampSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "medium", kind: "enum", T: proto3.getEnumType(Medium) },
    { no: 5, name: "textMessage", kind: "message", T: TextMessage },
    { no: 6, name: "emailMessage", kind: "message", T: EmailMessage },
    { no: 7, name: "phoneCall", kind: "message", T: PhoneCall },
    { no: 8, name: "recipientRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "session", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "taskBlock", kind: "message", T: TaskBlock },
    { no: 11, name: "task", kind: "message", T: Task },
    { no: 12, name: "taskChangeEvent", kind: "message", T: TaskChangeEvent },
    { no: 13, name: "videoRoom", kind: "message", T: VideoRoom },
    { no: 14, name: "document", kind: "message", T: Document },
    { no: 15, name: "secretName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "unread", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "forumPost", kind: "message", T: ForumPostEntry },
    { no: 18, name: "forumComment", kind: "message", T: ForumCommentEntry },
    { no: 19, name: "badge", kind: "message", T: BadgeEntry },
    { no: 20, name: "playbook", kind: "message", T: PlaybookEntry },
    { no: 21, name: "delegationTask", kind: "message", T: DelegationTask },
    { no: 22, name: "delegationTaskComment", kind: "message", T: DelegationTaskComment },
    { no: 23, name: "agentConversation", kind: "message", T: AgentConversationEntry },
    { no: 24, name: "agentCron", kind: "message", T: AgentCronEntry },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeedEntry {
    return new FeedEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeedEntry {
    return new FeedEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeedEntry {
    return new FeedEntry().fromJsonString(jsonString, options);
  }

  static equals(a: FeedEntry | PlainMessage<FeedEntry> | undefined, b: FeedEntry | PlainMessage<FeedEntry> | undefined): boolean {
    return proto3.util.equals(FeedEntry, a, b);
  }
}

